import { keyframes } from 'styled-components';

const slideLeft = keyframes`
  0% { transform: translateX(79%); }
  100% { transform: translateX(0%); }
`;

const slideRight = keyframes`
  0% { transform: translateX(-94%); }
  100% { transform: translateX(0%); }
`;

const slideUp = keyframes`
  0% { -webkit-transform: translateY(100%); }
  100% { -webkit-transform: translateY(0%); }
`;

const rotation = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;

const fadeIn = keyframes`
  0% { opacity: 0; }
  100% { opacity: 1; }
`;

const fadeOut = keyframes`
  0% { opacity: 1; }
  100% { opacity: 0; }
`;

const fadeInFromBottom = keyframes`
  from {
    opacity: 0;
    transform: translateY(15px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

export default { slideLeft, slideRight, slideUp, rotation, fadeIn, fadeOut, fadeInFromBottom };
